import { Component } from 'react';
import PropTypes from 'prop-types';

export default class Metrics extends Component {
  static propTypes = {
    metricsUrl: PropTypes.string.isRequired,
  };

  render() {
    return (
      <iframe
        frameBorder="0"
        allowFullScreen
        src={this.props.metricsUrl}
        style={{
          width: '100%',
          height: '700px',
        }}
      />
    );
  }
}
